import React from 'react';
import { Skeleton } from 'antd';
import { AkamProFooterIcon } from 'icons';
import Link from 'next/link';
import { useRouter } from 'next/router';

import { globalConst } from 'modules/global';
import { useProPrice } from 'modules/pro';

function AppDownSection() {
  const { locale = 'uz' } = useRouter();
  const { proPrice, isLoading } = useProPrice();
  const t = globalConst.extraTranslation.footer[locale as 'uz' | 'ru'];

  return (
    <div
      className="relative h-64 w-full bg-cover bg-center bg-no-repeat text-white md:h-80 lg:h-96"
      style={{ backgroundImage: 'url(/images/footer-bg.webp)' }}
    >
      <div className="relative z-10 flex h-full flex-col items-center justify-center p-6 text-center">
        <div className="text-xl font-semibold md:text-3xl">
          <AkamProFooterIcon />
        </div>
        <h2 className="mt-2 text-2xl font-bold md:text-4xl">{t?.pro_banner?.title}</h2>
        {/* eslint-disable-next-line i18next/no-literal-string */}
        <div className="mt-2 text-lg">
          {isLoading ? <Skeleton.Input active className="!h-5" /> : proPrice?.toLocaleString('ru')} sum/30 {t?.pro_banner?.day}
        </div>
        <Link
          href={globalConst.pageNames.PRO}
          className="mt-4 inline-block rounded-lg bg-gradient-to-r from-yellow-400 to-orange-500 px-6 py-2 text-center text-white shadow-md"
          aria-label={t?.pro_banner?.subscribe_pro}
        >
          {t?.pro_banner?.subscribe_pro}
        </Link>
      </div>
    </div>
  );
}

export default AppDownSection;
